import { useTranslation } from "react-i18next";
import { useAuth } from "@/lib/auth/useAuth";

export default function LoginPage() {
  const { t } = useTranslation();
  const { login } = useAuth();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4">
      <img
        src="/logo/sonia-by-fonestar-logotipo.svg"
        alt={t("app.title")}
        className="h-16 w-auto max-w-[80vw]"
      />
      <button
        onClick={() => login()}
        className="rounded bg-[var(--primary)] px-6 py-2 text-white font-medium"
      >
        {t("auth.login", "Iniciar sesion")}
      </button>
    </div>
  );
}
